import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 60000,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(undefined, async (error) => {
  const original = error.config || {};
  const url = original.url || "";
  if (error.response?.status !== 401 || original._retried || url.startsWith("/auth/")) throw error;
  original._retried = true;
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  try {
    await refreshing;
  } catch {
    throw error;
  }
  return api(original);
});

// Deux GET identiques lancés en même temps partagent la même requête réseau
const inflight = new Map();
const rawGet = api.get.bind(api);
api.get = (url, config) => {
  if (config?.signal || (config?.responseType && config.responseType !== "json")) return rawGet(url, config);
  const key = url + JSON.stringify(config?.params || {});
  if (!inflight.has(key)) inflight.set(key, rawGet(url, config).finally(() => inflight.delete(key)));
  return inflight.get(key);
};
